module.exports = __webpack_public_path__ + "img/hobbiton-3018-06-30.90716697.jpg";